<template>
    <div class="container">
      <CommonFrame
        :workNo="workNo"
        :btns="btns"
        :node="node"
        :breadcrumb="breadcrumb"
        :endStatus="approvalParams.endStatus"
        :approvalTabStatus="approvalParams.approvalTabStatus"
      >
        <div slot="info">
          <div class="info-container">
            <div class="info-item">
              <h4>退货单号：{{saleRefund.code}}</h4>
              <div class="info-wrap">
                <div class="info-wrap-item">所属门店：{{saleRefund.storeName}}</div>
                <div class="info-wrap-item">创建时间：{{saleRefund.createTime}}</div>
                <div class="info-wrap-item">创建人：{{saleRefund.createUserName}}</div>
              </div>
            </div>
          </div>
        </div>
        <div slot="tableInfo">
          <lk-card title="收款信息" class="other-card">
            <lk-form :label-width='134' label-position="right">
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="收款日期:">
                    <span>{{ saleRefund.proceedsTime}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="收款方式:">
                    <div>{{saleRefund.proceedsTypeName}}</div>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="收款金额:">
                    <div>{{saleRefund.proceedsAmount}}</div>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="购药人姓名:">
                    <span>{{saleRefund.paymentUserName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="联系方式:">
                    <div>{{saleRefund.paymentUserPhone}}</div>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="已核销金额:">
                    <div>{{saleRefund.receivables}}</div>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="已退款金额:">
                    <span>{{saleRefund.refundAmount}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="退货退回金额:">
                    <div>{{saleRefund.returnAmount}}</div>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="剩余预收款:">
                    <div>{{saleRefund.deposit}}</div>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </lk-card>
        <lk-card title="退款明细">
          <div>
            <lk-table :data="saleRefund.financeDepositRefundList" :columns="rejectColumn" class="rejectTable" border/>
          </div>
        </lk-card>
        </div>
      </CommonFrame>
    </div>
  </template>
<script>
import axios from 'axios';
import utils from '@/libs/utils';
import EditReturnExpand from '@/views/aftersale/EditReturnExpand.vue';
import CommonFrame from '../commonFrame.vue';

export default {
  name: 'SaleRefundApproval',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
  },
  data() {
    return {
      saleRefund: {},
      rejectColumn: [
        {
          title: '退款编号',
          minWidth: 116,
          key: 'code',
        },
        {
          title: '退款时间',
          minWidth: 116,
          key: 'approvalTime',
          render: (h, params) => h('span', params.row.approvalTime !== undefined ? utils.exchangeTimeToSecond(params.row.approvalTime) : ''),
        },
        {
          title: '发起人',
          minWidth: 116,
          key: 'createUserName',
        },
        {
          title: '退款方式',
          minWidth: 116,
          key: 'proceedsTypeName',
        },
        {
          title: '退款金额',
          minWidth: 116,
          key: 'amount',
        },
        {
          title: '退款原因',
          minWidth: 116,
          key: 'reason',
        },
      ],
      page: 1,
      size: 10,
      count: 0,
      workNo: '',
      node: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '预收退款审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
    };
  },
  methods: {
    getData() {
      axios.get(this.approvalParams.businessUrl).then((res) => {
        if (res.data.status === 200) {
          this.saleRefund = res.data.data;
          this.saleRefund.proceedsTime = utils.exchangeTime(this.saleRefund.proceedsTime);
          this.saleRefund.createTime = utils.exchangeTime(this.saleRefund.createTime);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },

  mounted() {
    this.getData();
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
  },
};
</script>

<style lang="less" scoped>
    .info-wrap{
    display: flex;
        .info-wrap-item{
            margin-right: 32px;
        }
    }
</style>